import { RefreshCw } from "lucide-react";

export function PageHeader({ title, description, onRefresh, refreshing, actions }:
{ title: string; description?: string; onRefresh?: () => void; refreshing?: boolean; actions?: React.ReactNode }) {
  return (
    <header className="page-header">
      <div><h1>{title}</h1>{description ? <p>{description}</p> : null}</div>
      <div className="page-header-actions">{actions}{onRefresh ? <button className="secondary-button" type="button" onClick={onRefresh} disabled={refreshing}><RefreshCw size={16} className={refreshing ? "spin" : ""} />Refresh</button> : null}</div>
    </header>
  );
}
